import { SeatDetails } from '@tff/types/TFF/tfa-amend-ancillary-service';
import * as TFF from '@tff/types/TFF';

export enum AncillaryType {
  Sports = 'SPORTS',
  Animals = 'ANIMALS',
  HandLuggage = 'HAND_LUGGAGE',
  Baggage = 'BAGGAGE',
  AdditionalBaggage = 'ADDITIONAL_BAGGAGE',
}

export type SeatsByPax = { [paxId: string]: SeatDetails };

export type SurchargeType = { [key: string]: string };

export type SsrsByPax = { [paxId: string]: TFF.SsrDetails[] };

export type SsrsByBond = {
  outbound: TFF.SsrDetails[];
  return: TFF.SsrDetails[];
};

export type PaxObject = Record<string, TFF.SsrDetails[]>;
